import { AlertsMoke } from "../../Services/Mocks/Alerts";
import { DashboardAlertFilters } from "./types";

export function getAlerts(filters: DashboardAlertFilters){
    let alertMoke = AlertsMoke.alerts;
    return alertMoke;
}